import {configData} from "./config";
import mqtt from "mqtt";

export const mqttClient = mqtt.connect(configData.mqtt_url);

mqttClient.on("connect", () => {
    console.log("Connected to MQTT Server");
    mqttClient.publish("connected", "websthira");
});
